import styled from 'styled-components';
import { PlusIcon } from '../icons';

interface DetailsAccessButtonProps {
  className?: string;
  isClicked?: boolean;
  onClick?: () => void;
}

export const DetailsAccessButton: React.FC<DetailsAccessButtonProps> = ({ className, isClicked, onClick }) => {
  return (
    <S.Container className={className} isClicked={!!isClicked} onClick={onClick}>
      <PlusIcon />
    </S.Container>
  );
};

const S = {
  Container: styled.div<{ isClicked: boolean }>`
    cursor: pointer;
    top: 8px;
    right: 8px;
    width: 20px;
    height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: ${({ theme }) => theme.white};
    border: 1px solid rgba(0, 70, 107, 0.1);
    border-radius: 4px;

    &:hover {
      border: 1px solid ${({ theme }) => theme.secondary.softBlue1};
    }

    ${({ theme, isClicked }) =>
      isClicked
        ? `
            border: 1px solid ${theme.secondary.softBlue1};
            background: ${theme.secondary.softBlue1};
            path {
                fill: ${theme.white}
            }
        `
        : ''}
  `,
};
